export default __webpack_public_path__ + "static/media/Group 10873_1.315c9a5b.svg";